<div class="jobs-wrapper">

    <div class="photo-header text-center flex items-center" style="background-image: url(../assets/img/job-opportunities-hero-bg.jpg)">

        <div class="mx-auto">

            <h1 class="uppercase text-white font-display font-normal photo-header__headline flex flex-wrap jobstitle">
                Job Opportunities
            </h1>

        </div>

    </div>
    <!--/photo-header-->

    <div class="mx-auto my-12 lg:mt-20 lg:mb-2 container container-padding">

        <div class="max-w-lg mx-auto mb-12 lg:mb-2">

            <embed class="jobwindow" src="https://recruiting.paylocity.com/recruiting/jobs/All/d5ecdaba-4cfc-4157-8be1-bc160dd54d27/Jamestown-Distributors/" width=100% height=1300 onerror="document.write('We\'re sorry, that job does not exist or is not currently active.');" />

        </div>

    </div>

    <!-- <div class="mx-auto my-12 lg:mt-20 lg:mb-2 container container-padding">

        <div class="max-w-lg mx-auto mb-12 lg:mb-2">

            <div class="uppercase text-5xl font-display lines-left-red">
                Join the Team
            </div>

            <p>At Jamestown we are strong believers that happy employees make for happy customers. We want all of our employees to be successful and proud of their work. We encourage creativity and personality in the pursuit of constantly improving. We like
                to work hard and have fun. And we love what we do and who we work with.</p>

            <p><strong>We are looking for individuals to fill the following positions:</strong></p>

        </div>

    </div> -->

    <!-- <div class="mx-auto mb-12 container container-padding">

        <div class="max-w-lg mx-auto mb-12 lg:mb-20">

            <div *ngFor="let job of jobsArray?.jobs" class="bg-grey-lightest p-6 pt-2 rounded-lg text-sm job-opportunity">

                <strong class="text-30px">{{job.jobTitle}}</strong>

                <div class="my-6">
                    <div class="font-display opacity-50 text-22px uppercase">Position Outline</div>
                    {{job.positionOutline}}
                </div>

                <div class="my-6">
                    <div class="font-display opacity-50 text-22px uppercase">Primary Responsibilities</div>
                    <ul [innerHtml]="job.primaryResponsibilities"></ul>
                </div>

                <div class="my-6">
                    <div class="font-display opacity-50 text-22px uppercase">Desired Qualifications</div>
                    <ul [innerHTML]="job.desiredQualifications">

                    </ul>
                </div>

                <div class="font-bold mb-3">
                    To apply for this position, please send us your resume at
                    <a class="emailLink" href="mailto:employment@jamestowndistributors.com">employment@jamestowndistributors.com</a>
                </div>
                <div class="text-sm">{{job.equalOpportunityEmployer}}</div>

            </div>



        </div>

    </div> -->

    <support-footer></support-footer>

</div>
<!--/home-wrapper-->
